module.exports = __webpack_public_path__ + "static/media/ImageA.f1149284.jpg";